var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardFancy',_vm._b({staticClass:"CardSplit"},'CardFancy',_vm.$props,false),[_c('Row',[_c('Column',{attrs:{"md":8}},[_vm._t("left")],2),_c('Column',{attrs:{"md":4}},[_vm._t("right")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }